import darkenjs from "./composed/darkenjs.js";
// import lazyLoad from "./composed/lazy-load.js";
import swupInit from "./composed/swupjs.js";
import setupMenu from "./composed/setup-menu.js";
import scrollReveal from "./composed/scroll-reveal.js";
import splide from "./composed/splide.js";
import jarallaxjs from "./composed/jarallaxjs.js";
import glightboxjs from "./composed/glightboxjs.js";
import gridzy from "./composed/gridzy/gridzy.js";
import mixitupjs from "./composed/mixitup/mixitupjs.js";
import BackgroundSourceSet from "./composed/BGSrcset.js";
import plyrjs from "./composed/plyrjs.js";
// import matchheight from "./composed/match-height.js";
import placeholderLabels from "./composed/placeholder-labels.js";
import headerscroll from "./composed/headerscroll.js";
import searchModal from "./composed/search-modal.js";
// import SlideNav from "./composed/slide-nav.js"; //quiet

document.addEventListener("DOMContentLoaded", firstLoadInit);

const bgss = new BackgroundSourceSet();
bgss.callonce = false;

const swup = swupInit(".gn-swup-wrapper");

function genericInit() {
    headerscroll.init();
    mixitupjs.init();
    darkenjs.init();
    glightboxjs.init();
    gridzy.init();
    jarallaxjs.init();
    plyrjs.init();
    splide.init();
    // matchheight.init();
    placeholderLabels.init();
    scrollReveal.init();
    searchModal.init();

    const gnInitEvent = new Event("gnInit");
    document.dispatchEvent(gnInitEvent);

    //adding class to style search results page
    if (window.location.href.indexOf("&action_results=Go") > -1) {
        document.body.classList.remove("SolidMenu");
    }

    if (window.location.href.indexOf("?filter=") > -1) {
        document.body.classList.add("Show_SmartPag");
    }

    // new SlideNav({ speed: 10 });

    bgss.init(".BGImage", function (a) {
        a.node.classList.add("loaded");
    });

    //lazyLoad();
}

/**
 * This script cleans up JS which is will no longer be needed on page change
 */
function cleanupScripts() {
    glightboxjs.cleanup();
    scrollReveal.cleanup();
    jarallaxjs.cleanup();
    splide.cleanup();
    gridzy.cleanup();
    mixitupjs.cleanup();
    plyrjs.cleanup();
    scrollReveal.cleanup();
}

swup.hooks.before('content:replace', () => { cleanupScripts() });

// init js when Swup has replaced page
swup.hooks.on('content:replace', () => { pageSwapInit() });

// run some things when links are clicked.
swup.on("clickLink", () => {
    setupMenu.closeMenus();
});

function pageSwapInit() {
    genericInit();
}

function firstLoadInit() {
    setupMenu.init();

    //adding class to style search results page
    if (window.location.href.indexOf("&action_results=Go") > -1) {
        document.body.classList.remove("SolidMenu");
    }

    if (window.location.href.indexOf("?filter=") > -1) {
        document.body.classList.add("Show_SmartPag");
    }

    genericInit();
}
